module.exports = "/_next/static/images/Hero-1c70931d93a7237f6c5ad9cf4d90daae.webp";